import { render, staticRenderFns } from "./trainingTemplate.vue?vue&type=template&id=f437b2a4&scoped=true"
import script from "./trainingTemplate.vue?vue&type=script&lang=js"
export * from "./trainingTemplate.vue?vue&type=script&lang=js"
import style0 from "./trainingTemplate.vue?vue&type=style&index=0&id=f437b2a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f437b2a4",
  null
  
)

export default component.exports